// Module
var code = `<div class="customer-picker">

  <div class="picker-form">
    <input class='picker-query'
           type="text"
           placeholder="Lookup customer"
           ng-model="\$ctrl.query"
           ng-keydown="\$event.which === 13 && \$ctrl.search()"
           autocomplete="off">
    <button class="btn btn-primary"
            type="submit"
            ng-click="\$ctrl.search()"
            ng-disabled="!\$ctrl.query">Search</button>
  </div>

  <div class="picker-content" ng-show="\$ctrl.visible">
    <table ng-show="\$ctrl.searchResults.length > 0" class="table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Birth date</th>
        <th>CIF number</th>
        <th>Mother branch</th>
        <th>Type</th>
        <th>&nbsp;</th>
      </tr>
      </thead>

      <tbody>
      <tr ng-repeat="result in \$ctrl.searchResults">
        <td>{{result.effectiveName}}</td>
        <td>{{result.birthDate | prettyDate}}</td>
        <td>{{result.customerNumber}}</td>
        <td>{{result.branch.name}}</td>
        <td>{{result.customerType | prettyEnum}}</td>
        <td>
          <button ng-click="\$ctrl.choose(result, \$event)"
                  type="button"
                  class="btn btn-primary">
            Choose
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="no-results" ng-show="\$ctrl.searchResults.length == 0">
      No customers have been found.
    </div>

  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/customer-picker/customer-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;